// /news — the latest post up top, press contacts, then every post.
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Seo from '../site/Seo';
import { SOCIALS } from '../site/siteLinks';
import { POSTS, formatPostDate } from './posts';
import './news.css';

const PostCard = ({ post, featured }) => (
  <Link to={`/news/${post.slug}`} className={`nr-card${featured ? ' nr-card--featured' : ''}`}>
    <div className="nr-card-cover">
      <img src={post.cover} alt={post.coverAlt} loading={featured ? 'eager' : 'lazy'} />
    </div>
    <div className="nr-card-body">
      <p className="nr-meta"><span className="nr-category">{post.category}</span> · <time dateTime={post.date}>{formatPostDate(post.date)}</time></p>
      <h3 className="nr-card-title">{post.title}</h3>
      {featured && <p className="mk-text">{post.description}</p>}
    </div>
  </Link>
);

const NewsRoom = () => {
  const [latest] = POSTS;
  return (
    <>
      <Seo
        title="Bumpups | Newsroom"
        description="Stay up-to-date with the latest from Bumpups. Our newsroom delivers cutting-edge product updates, exciting announcements, and industry insights on how our AI-driven video intelligence is transforming raw content into actionable data."
      />

      <section className="nr-hero mk-hero-bg">
        <div className="mk-container">
          <h1 className="mk-h1">Newsroom</h1>
          <p className="mk-lead">Product updates and announcements from the Bumpups team.</p>
        </div>
      </section>

      <section className="mk-container nr-top">
        <PostCard post={latest} featured />
        <aside className="mk-card nr-press">
          <div>
            <p className="nr-press-label">Press inquiries</p>
            <a href="mailto:press@bumpups.com" className="nr-press-email">press@bumpups.com</a>
          </div>
          <div>
            <p className="nr-press-label">Non-media inquiries</p>
            <a href="mailto:contact@bumpups.com" className="nr-press-email">contact@bumpups.com</a>
          </div>
          <div>
            <p className="nr-press-label">Follow Bumpups</p>
            <div className="mk-socials">
              {SOCIALS.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`Bumpups on ${s.label}`} className="mk-social">
                  <FontAwesomeIcon icon={s.icon} />
                </a>
              ))}
            </div>
          </div>
        </aside>
      </section>

      <section className="mk-section">
        <div className="mk-container">
          <h2 className="mk-h2 nr-all-title">All news</h2>
          <div className="mk-grid mk-grid--3">
            {POSTS.map(post => <PostCard key={post.slug} post={post} />)}
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsRoom;
